import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["eventId", "sessionId"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation } from '@tanstack/react-query';
import api from 'utils/api';
// useMutation is intentional here: this call is imperative, triggered by the
// user submitting a selection, not on component mount. useQuery would
// auto-fetch on render and re-fetch on focus/remount, which is not wanted.
function useCheckEventSessionAttendeesEligibility(_ref) {
  var eventId = _ref.eventId,
    sessionId = _ref.sessionId,
    options = _objectWithoutProperties(_ref, _excluded);
  function checkEventSessionAttendeesEligibility(_x) {
    return _checkEventSessionAttendeesEligibility.apply(this, arguments);
  }
  function _checkEventSessionAttendeesEligibility() {
    _checkEventSessionAttendeesEligibility = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var _ref2$userIds, userIds, _ref2$teamIds, teamIds, _yield$api, _yield$api$hasAccessU, hasAccessUsers, _yield$api$conflictUs, conflictUsers, _yield$api$noAccessUs, noAccessUsers;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref2$userIds = _ref2.userIds, userIds = _ref2$userIds === void 0 ? [] : _ref2$userIds, _ref2$teamIds = _ref2.teamIds, teamIds = _ref2$teamIds === void 0 ? [] : _ref2$teamIds;
            if (!(!userIds.length && !teamIds.length)) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return", {
              hasAccessUsers: [],
              conflictUsers: [],
              noAccessUsers: []
            });
          case 1:
            _context.next = 2;
            return api('get', "/api/assets/".concat(eventId, "/sessions/").concat(sessionId, "/attendees/check-eligibility"), {
              userIds: userIds.length ? JSON.stringify(userIds) : undefined,
              teamIds: teamIds.length ? JSON.stringify(teamIds) : undefined
            });
          case 2:
            _yield$api = _context.sent;
            _yield$api$hasAccessU = _yield$api.hasAccessUsers;
            hasAccessUsers = _yield$api$hasAccessU === void 0 ? [] : _yield$api$hasAccessU;
            _yield$api$conflictUs = _yield$api.conflictUsers;
            conflictUsers = _yield$api$conflictUs === void 0 ? [] : _yield$api$conflictUs;
            _yield$api$noAccessUs = _yield$api.noAccessUsers;
            noAccessUsers = _yield$api$noAccessUs === void 0 ? [] : _yield$api$noAccessUs;
            return _context.abrupt("return", {
              hasAccessUsers: hasAccessUsers,
              conflictUsers: conflictUsers,
              noAccessUsers: noAccessUsers
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _checkEventSessionAttendeesEligibility.apply(this, arguments);
  }
  var _useMutation = useMutation(_objectSpread({
      mutationFn: checkEventSessionAttendeesEligibility
    }, options)),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    checkEventSessionAttendeesEligibility: mutateAsync
  });
}
export default useCheckEventSessionAttendeesEligibility;